import { gql } from "@apollo/client";

export const GET_INSTRUCTOR_DETAIL = gql`
  query InstructorDetail($id: Int!) {
    instructorProfile(id: $id) {
      id
      name
      instructorImage
      instructorImageHorizontal
      instructorDescription
      instructorDescriptionHtml

      # tagTitle
      # tagDescription
      # tagKeywords
      # ogType
      # ogSiteName
      # ogTitle
      # ogDescription
      # ogImage
      # ogImageWidth
      # ogImageHeight
      # ogImageAlt
      # ogImageType
      # googleTag

      halls {
        id
        title
        instructorActivities {
          id
          title
        }
      }
    }
  }
`;

export const GET_INSTRUCTORS = gql`
  query Instructors($hallId: Int!) {
    instructors(hallId: $hallId) {
      id
      name
      instructorImage
      isInstructorVisible
      instructorDescription
    }
  }
`;
